<app-wizard-step-wrapper
  [showStep]="showStep"
  [stepTitle]="stepMetadata.stepName"
  [formGroup]="formStep"
  [hideHeader]="true"
  >
  <h2 class="form-step__header" data-testid="check-in-header">
    Security Questions
  </h2>
  <h3 class="form-step__subheading">
    You have 2 minutes to submit all the questions. We use these to verify your identity. Do not refresh the page.
  </h3>
  @if (kbaQuestions) {
    <form class="kba-questions" [formGroup]="kbaQuestions" data-private>
      <app-stepper #cdkStepper tabindex="5" [ariaLabelText]="'questions'">
        @for (question of questionSet.questions; track question; let questionIndex = $index) {
          <cdk-step>
            <ng-template cdkStepLabel>
              @if (kbaQuestions.controls[question.questionId].invalid) {
                <span>{{
                  questionIndex + 1
                }}</span>
              }
              @if (kbaQuestions.controls[question.questionId].valid) {
                <svg
                  width="15"
                  height="12"
                  viewBox="0 0 15 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  >
                  <path
                    d="M4.65833 8.81667L1.18333 5.34167L0 6.51667L4.65833 11.175L14.6583 1.175L13.4833 0L4.65833 8.81667Z"
                    fill="white"
                    />
                  </svg>
                }
              </ng-template>
              <fieldset class="question">
                <legend class="question__text">
                  {{ questionIndex + 1 }}. {{ question.text.statement }}
                </legend>
                @if (cdkStepper.isLastStep() && unansweredQuestions().trim().length) {
                  <p class="error-message"
                    >
                    You still have to answer previous {{unansweredQuestions().length > 1 ? "questions " : "question "}} {{ unansweredQuestions() }} before clicking Submit.
                  </p>
                }
                @if (
                  kbaQuestions.controls[question.questionId].invalid &&
                  (kbaQuestions.controls[question.questionId].dirty ||
                  kbaQuestions.controls[question.questionId].touched)
                  ) {
                  <p
                    class="error-message"
                    >
                    {{ "Please answer the question before clicking " + (cdkStepper.isLastStep() ? "Submit." : "Next.") }}
                  </p>
                }
                <div class="choices">
                  <mat-radio-group formControlName="{{ question.questionId }}" class="rkt-Fieldset">
                    @for (choice of question.choices; track choice) {
                      <mat-radio-button
                        class="choice rkt-Radio"
                        [value]="choice.choiceId"
                        id="{{ choice.choiceId }}"
                        >
                        {{ choice.text.statement }}
                      </mat-radio-button>
                    }
                  </mat-radio-group>
                  @if (question.helpText?.statement) {
                    <p class="question__help-text">
                      {{ question.helpText.statement }}
                    </p>
                  }
                </div>
              </fieldset>
              <app-button-container>
                @if (!cdkStepper.isFirstStep()) {
                  <app-button
                    type="tertiary"
                    (buttonClick)="cdkStepper.previous()"
                    [dataTestId]="'back-kba-questions'"
                    >Back
                    </app-button
                    >
                  }
                  @if (!cdkStepper.isLastStep()) {
                    <app-button
                      type="primary"
                      (buttonClick)="answer(question.questionId)"
                      [dataTestId]="'next-kba-questions'"
                      >Next
                      </app-button
                      >
                    }
                    @if (cdkStepper.isLastStep()) {
                      <app-button
                        type="primary"
                        [isDisabled]="!!unansweredQuestions()"
                        (buttonClick)="goToNextStep()"
                        [dataTestId]="'next-button-kba-questions'"
                        >Submit
                        </app-button
                        >
                      }
                    </app-button-container>
                  </cdk-step>
                }
              </app-stepper>
            </form>
          }
        </app-wizard-step-wrapper>
